import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/admin/usable/SearchBar";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";
import TableLoader from "../../../components/admin/usable/TableLoader";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import { useNavigate } from "react-router";
import { deleteTour, getTourList } from "../../../api/admin/tourApi";

const TourList = () => {
  const navigate = useNavigate();
  const [TourData, setTourData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(20);
  const [PageData, setPageData] = useState("");
  useEffect(() => {
    getTourList(setTourData, Page, Limit, setPageData);
  }, [Page, Limit]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(TourData);
    } else {
      const result = TourData.filter((item) =>
        item.tourName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, TourData]);
  const handleDelete = (item) => {
    const id = item.id;
    deleteTour(setTourData, setPageData, Page, Limit, id);
  };
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search Tour"
        />
        <AddButton
          onClick={() => navigate("/admin/tour/create")}
          text="Add Tour"
        />
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Tour Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Location
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Company Logo
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Company Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Commission Rate
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Duration
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Price
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Discount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {FilteredData.length > 0 ? (
              <>
                {FilteredData.map((item, index) => {
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.tourName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.city}, {item.country}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-20 h-8 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-contain"
                            src={item.companyLogo}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.companyName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.commissionRate || 0}%
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.startDate.split("T")[0]} to{" "}
                        {item.endDate.split("T")[0]}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.price || 0} BDT
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.discount || 0}%
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.createdAt.slice(0, 10)}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <div className="flex gap-x-2">
                          <EditButton
                            onClick={() =>
                              navigate(`/admin/tour/edit/${item.id}`)
                            }
                          />
                          <DeleteButton onClick={() => handleDelete(item)} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <TableLoader colSpan={11} />
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {TourData.length} of {PageData} entries
        </p>
        <Pagination count={PageData || 1} />
      </div>
    </div>
  );
};

export default TourList;
